import { createFileRoute } from '@tanstack/react-router';
import { OnboardingShell } from '@/components/onboarding/OnboardingShell';
import { PROFILE_FORM_ID, ProfileStep } from '@/components/onboarding/ProfileStep';
import { StepFooter } from '@/components/onboarding/StepFooter';
import { useMe } from '@/lib/queries/identity';

export const Route = createFileRoute('/onboarding/profile')({
  component: OnboardingProfilePage,
});

function OnboardingProfilePage() {
  const { data, isError } = useMe();
  // Mirror the old server page: swallow fetch errors and hand `undefined`
  // to ProfileStep so it falls back to defaults.
  //
  // `place` hydration: ProfileSelfResponse still exposes the legacy flat
  // `location` field via OpenAPI (server view migration is Wave 2). With no
  // placeId/lat/lng available, we can't hydrate a real `PlaceSelection` —
  // the picker starts empty and the user re-picks. The backfill agent's
  // migration covers existing DB rows server-side.
  const initialProfile =
    data !== undefined && !isError
      ? {
          firstName: data.firstName,
          lastName: data.lastName ?? '',
          jobTitle: data.jobTitle ?? '',
          industry: data.industry ?? '',
          place: null,
          displayName: [data.firstName, data.lastName].filter(Boolean).join(' '),
          ...(data.photoUrl !== undefined ? { photoUrl: data.photoUrl } : {}),
        }
      : undefined;

  return (
    <OnboardingShell
      title="Create your profile."
      footer={
        <StepFooter formId={PROFILE_FORM_ID} primaryLabel="Continue" />
      }
    >
      <ProfileStep initialProfile={initialProfile} />
    </OnboardingShell>
  );
}
